import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_URL } from "../../../constants";
import { useNavigate } from "react-router-dom";

const CostPerSeat = () => {
  const [costPerSeat, setCostPerSeat] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const userToken = useSelector((s) => s.login.data.token);
  const navigate = useNavigate();

  useEffect(() => {
    getRoutePrice();
  }, []);

  const getRoutePrice = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${API_URL}/api/v1/seatCostDriver`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });
      const jsonresponse = await response.json();
      if (jsonresponse.success === true) {
        setCostPerSeat(jsonresponse.data);
      } else {
        setError("Failed to fetch cost. Please try again.");
      }
    } catch (error) {
      setError("An error occurred while fetching the cost.");
    } finally {
      setIsLoading(false);
    }
  };

  const cost_button = {
    backgroundColor: "#FFC738",
    color: "white",
    paddingLeft: "40px",
    paddingRight: "40px",
    marginTop: "20px",
    fontSize: "20px",
  };

  const handleButtonClick = () => {
    navigate("/dashboard");
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        backgroundColor: "#01183F",
        color: "white",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <div className="d-flex flex-column justify-content-center align-items-center h-100 text-center p-5 overflow-hidden">
        {isLoading ? (
          <h1>Loading...</h1>
        ) : error ? (
          <h1>{error}</h1>
        ) : (
          <>
            <h1>
              According to the car and route information you shared, your
              estimated
            </h1>
            <h1>cost per seat per day (round trip) is </h1>
            <h1>
              Rs. {costPerSeat || "N/A"} on a cost-sharing basis
            </h1>
            <h4 style={{ color: "#FFD700", marginBottom: "20px" }}>
              (This cost includes 10% maintenance charges)
            </h4>
            <h1>
              This cost will be adjusted fortnightly according to changes in
              fuel prices
            </h1>
            <button
              className="btn"
              style={cost_button}
              onClick={handleButtonClick}
            >
              Next
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CostPerSeat;
